export default __webpack_public_path__ + "static/media/2x2_pink.8796e5fc.png";